import axios from "axios";
import { securePostAPI } from "./apiService";
import { apiConfig } from "../../config";

const API_BASE_URL = apiConfig.apiformbaseurl;

export async function fetchFormsForUser(userId, rollNumber) {
  try {
    const batchCourseData = await securePostAPI({ userId }, "mysa/student/getBatchCourse");
  
    const { batchId: studentBatchId, courseId: studentCourseId } = batchCourseData || {};
 
    if (!studentBatchId || !studentCourseId) {
      return [];
    }
  localStorage.setItem("studentBatchId", studentBatchId);
  localStorage.setItem("studentCourseId", studentCourseId);
    const parentFormsResponse = await securePostAPI(
      { batchId: studentBatchId, courseId: studentCourseId },
      "mysa/student/forms/byBatchCourse"
    );
    const parentForms = parentFormsResponse?.forms || [];

    const filteredChildren = parentForms.flatMap(parentForm =>
      (parentForm.childFormsInfo || [])
        .filter(child =>
          child.batchId === studentBatchId &&
          child.courseId === studentCourseId
        )
        .map(child => ({
          ...child,
          startAt: parentForm.startAt,
          endAt: parentForm.endAt,
          parentFormTitle: parentForm.title,
          studentBatchId,
          studentCourseId
        }))
    );

    if (filteredChildren.length === 0) {
      return [];
    }

    const childFormIds = filteredChildren.map(form => form.childFormId);
    let submissionResponse = {};
    try {
      const resp = await axios.post(`${API_BASE_URL}/forms/check-submissions/${rollNumber}`, {
        formIds: childFormIds
      });
      submissionResponse = resp.data || {};
    } catch (submissionError) {
      console.error('Error checking submission status:', submissionError);
    }

    return filteredChildren.map(form => ({
      ...form,
      hasSubmitted: submissionResponse[form.childFormId] === true,
      submissionStatus: submissionResponse[form.childFormId] || false
    }));

  } catch (err) {
    console.error("Error fetching forms for user:", err);
    return [];
  }
}

export async function checkUserFormAccess(childFormId, studentCourseId, studentBatchId) {
  try {
    const res = await axios.get(`${API_BASE_URL}/forms/check-user-form/${childFormId}/${studentCourseId}/${studentBatchId}`);
    return res.data;
  } catch (err) {
    console.error("Error checking form access:", err);
    throw err;
  }
}

export async function getStudentBatchCourse(userId) {
  try {
    const batchCourseData = await securePostAPI({ userId }, "mysa/student/getBatchCourse");
    const { batchId, courseId } = batchCourseData || {};
    return { batchId, courseId };
  } catch (err) {
    console.error("Error getting student batch/course:", err);
    return { batchId: null, courseId: null };
  }
}

export async function submitFormAnswers(childFormId, payload) {
  const res = await axios.post(`${API_BASE_URL}/forms/${childFormId}/submit`, payload); 
  return res.data;
}

export async function fetchFormDetail(formId) {
  try {
    let res= await axios.get(`${API_BASE_URL}/forms/${formId}`);

    return res.data;
  } catch (err) {
    console.error("Error fetching form detail:", err);
    throw err;
  }
}

